import { render, staticRenderFns } from "./SwapLoadingStep.vue?vue&type=template&id=9201e2e4&scoped=true"
import script from "./SwapLoadingStep.vue?vue&type=script&lang=ts"
export * from "./SwapLoadingStep.vue?vue&type=script&lang=ts"
import style0 from "./SwapLoadingStep.vue?vue&type=style&index=0&id=9201e2e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9201e2e4",
  null
  
)

export default component.exports